import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

const vuexPersistence = new VuexPersistence({
  storage: localStorage,
  key: 'TrackMe',
  reducer: (state) => ({
    loggedIn: state.loggedIn,
    token: state.token,
    email: state.email,
    fullname: state.fullname
  })
})
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedIn: false,
    token: null,
    email: null,
    fullname: null,
    goalIsSet: false,
    goalData: null,
    progress: 0,
    completedGoals: 0,
    selectedCriterial: null
  },
  getters: {
    isLoggedIn: state => state.loggedIn,
    getToken: state => state.token,
    getFullname: state => state.fullname,
    getGoalData: state => state.goalData,
    isGoalSet: state => state.goalIsSet,
    getSelected: state => state.selectedCriterial
  },
  mutations: {
    setUser (state, user) {
      state.token = user.token
      state.email = user.email
      state.fullname = user.username
      state.loggedIn = true
    },
    setGoalData (state, data) {
      state.goalData = data
      state.goalIsSet = true
    },
    clearGoalData (state) {
      state.goalData = null
      state.goalIsSet = false
    },
    clearData (state) {
      state.token = null
      state.email = null
      state.fullname = null
      state.goalData = null
      state.goalIsSet = false
    },
    criterial (state, data) {
      state.selectedCriterial = data
    }
  },
  actions: {
    user ({ commit }, data) {
      commit('setUser', data)
    },
    setStoreGoal ({ commit }, data) {
      console.log('In set goal')
      console.log(data)
      commit('setGoalData', data)
    },
    clearGoal ({ commit }) {
      commit('clearGoalData')
    },
    clearAll ({ commit }) {
      commit('clearData')
    },
    setCriterial ({ commit }, data) {
      commit('criterial', data)
    }
  },
  modules: {
  },
  plugins: [vuexPersistence.plugin]
})
